import React from 'react';
import PropTypes from 'prop-types';
import { getClassName } from '../../../utils/ui/classes';
function ArrowTopRightOnSquareIcon({ className, type }) {
    if (type === 'solid') {
        return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 28 28", fill: "currentColor", className: getClassName(className) },
            React.createElement("path", { fillRule: "evenodd", d: "M15.75 2.25H21a.75.75 0 01.75.75v5.25a.75.75 0 01-1.5 0V4.81L8.03 17.03a.75.75 0 01-1.06-1.06L19.19 3.75h-3.44a.75.75 0 010-1.5zm-10.5 4.5a1.5 1.5 0 00-1.5 1.5v10.5a1.5 1.5 0 001.5 1.5h10.5a1.5 1.5 0 001.5-1.5V10.5a.75.75 0 011.5 0v8.25a3 3 0 01-3 3H5.25a3 3 0 01-3-3V8.25a3 3 0 013-3h8.25a.75.75 0 010 1.5H5.25z", clipRule: "evenodd" })));
    }
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 30 30", strokeWidth: 1.5, stroke: "currentColor", className: getClassName(className) },
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" })));
}
ArrowTopRightOnSquareIcon.propTypes = {
    type: PropTypes.oneOf(['solid', 'outline']),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
};
ArrowTopRightOnSquareIcon.defaultProps = {
    type: 'solid',
    className: 'w-6 h-6',
};
export default ArrowTopRightOnSquareIcon;
